export default "__VITE_ASSET__DgTF1bCK__"